"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_popper_1 = require("react-popper");
function usePopperJs({ targetRef, popperProps, isOpen }) {
    /* These must be useState and not useRef. */
    const [arrowEle, setArrowEle] = react_1.useState(null);
    const [popperEle, setPopperEle] = react_1.useState(null);
    const { styles, forceUpdate, attributes } = react_popper_1.usePopper(targetRef === null || targetRef === void 0 ? void 0 : targetRef.current, popperEle, Object.assign({ placement: 'bottom', modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 15], // adds offset away from y pos
                },
            },
            {
                name: 'preventOverflow',
                options: { padding: 20 }, // this mimics as if the body has a 20px padding like a boundary
            },
            {
                name: 'arrow',
                options: { element: arrowEle },
            },
            {
                name: 'computeStyles',
                options: {
                    // allows us to use both popper and framer on same div.
                    gpuAcceleration: false, // true by default
                },
            },
        ] }, popperProps));
    react_1.useEffect(() => {
        if (!isOpen) {
            return;
        }
        const t = setTimeout(() => {
            forceUpdate === null || forceUpdate === void 0 ? void 0 : forceUpdate();
        }, 0);
        return () => clearTimeout(t);
    }, [isOpen, forceUpdate]);
    return {
        arrowEle,
        setArrowEle,
        popperEle,
        setPopperEle,
        styles,
        attributes,
    };
}
exports.default = usePopperJs;
